import Vue from 'vue'
const trigger = (el, type) => {
  const e = document.createEvent('HTMLEvents')
  e.initEvent(type, true, true)
  el.dispatchEvent(e)
}
export default () => {
  // 针对 input做的限制
  // 正只能输入正整数
  Vue.directive('positiveInt', {
    bind(el) {
      const input = el.getElementsByTagName('input')[0]
      input.onkeyup = function(e) {
        input.value = input.value.replace(/[^0-9]/g, '')
        trigger(input, 'input')
      }
      input.onblur = function(e) {
        input.value = input.value.replace(/[^0-9]/g, '')
        trigger(input, 'input')
      }
    }
  })
}
